import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ActionAreaCard from './ActionAreaCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, ActionAreaCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/action-area/ActionAreaCard.tsx",
    "fileName": "ActionAreaCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Typography from '@mui/material/Typography';\nimport CardActionArea from '@mui/material/CardActionArea';\n\nexport default function ActionAreaCard() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card sx={{ maxWidth: 345 }}>\n      <CardActionArea>\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"/static/images/cards/contemplative-reptile.jpg\"\n          alt=\"green iguana\"\n        />\n        <CardContent>\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Lizard\n          </Typography>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            Lizards are a widespread group of squamate reptiles, with over 6,000\n            species, ranging across all continents except Antarctica\n          </Typography>\n        </CardContent>\n      </CardActionArea>\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 29,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Typography from '@mui/material/Typography';\nimport CardActionArea from '@mui/material/CardActionArea';\n\nexport default function ActionAreaCard() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card sx={{ maxWidth: 345 }}>\n      <CardActionArea>\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"/static/images/cards/contemplative-reptile.jpg\"\n          alt=\"green iguana\"\n        />\n        <CardContent>\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Lizard\n          </Typography>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            Lizards are a widespread group of squamate reptiles, with over 6,000\n            species, ranging across all continents except Antarctica\n          </Typography>\n        </CardContent>\n      </CardActionArea>\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 29,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Card",
      "@mui/material/CardContent",
      "@mui/material/CardMedia",
      "@mui/material/Typography",
      "@mui/material/CardActionArea"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
